module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks-Academy_Poster-3cfe6add543a64e0c13b9cfaa3ba8dc6.webp";